module.exports = __webpack_public_path__ + "img/Edit-link.019a5a35.gif";